// removed by extract-text-webpack-plugin
module.exports = {"pulse-indicator":"pulse-indicator","pulse":"pulse","pulse-inner":"pulse-inner"};


//////////////////
// WEBPACK FOOTER
// ./src/common/component/loader/component/pulse-indicator/pulse-indicator.style.sass
// module id = hVMN
// module chunks = 3